<template>
  <div class="home">
    <v-container fill-height>
      <v-row justify="center" align="center">
        <v-col cols="12" md="auto" class="info-banner">
          <span align="center" class="phone"
            ><a href="tel:3019220524"> CALL US: 301-922-0524</a></span
          >
        </v-col>
        <v-col cols="12" md="auto" class="info-banner">
          <span class="ml-5" style="font-weight:700">
            <v-icon size="24px">mdi-map-marker</v-icon>
            DC, Maryland, Virginia</span
          >
        </v-col>
      </v-row>
    </v-container>
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home",
  components: {
    HelloWorld
  }
};
</script>
<style>
.info-banner {
  /* height: 110px; */
  text-align: center;
}
.phone {
  font-size: 1.5rem;
  color: #1a79bb;
  font-weight: 700;
}
</style>
